<template>
<div>

        <section
        style='cursor: pointer'>
           <v-img @click='home()'
        v-if='$vuetify.breakpoint.xsOnly'
          class='white'
          src="../../assets/staticAsset/headerXs.png"
          contain
        >

        </v-img>
        <v-img @click='home()' v-if='!$vuetify.breakpoint.xsOnly'
          class='white'
          src="../../assets/staticAsset/header.png"
          contain>
          <v-btn
            style='float:right'
            color='primary'
            href="/login">Login</v-btn>

        </v-img>
      </section>
      <section>
        <v-card outlined flat color='#399342' class='mt-n1 white--text'>
               <v-col
        md="4"
        offset-md="1"
      >
         <p class="mt-2 headline font-weight-bold text-center" > {{title}}</p>
               </v-col>
        </v-card>


      </section>
</div>
</template>

<script>
import router from "../../router"
export default {
    props : {
        title : String,
        image : String
    },
    methods : {
      home() {
        router.push('/');
      }
    }
}
</script>

<style>
 .headerimg:hover {
   cursor: pointer;
 }
</style>
